import { Link } from "react-router-dom";
import { H1Title, Paragraph } from "../components/typography/typography";
import { AppButton } from "../components/buttons/button";

export default function ErrorPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-grey-bg">
      <div className="text-center">
        <H1Title size="2xl" className="text-primary">404</H1Title>
        <Paragraph size="lg" className="text-grey-667 mt-2 mb-6">Page not found</Paragraph>
        <Link to="/">
          <AppButton fullWidth={false} className="px-8">
            Go Home
          </AppButton>
        </Link>
      </div>
    </div>
  );
}
